<template>
    <div class="chat">
        <!--header-->
        <header class="header">
            <img class="navBack pull-left" @click.stop="back()" src="../../../static/images/shootShop/back.png" alt="" >
            <span class="title">{{stat.currentUserInfo.nickname}}</span>
        </header>
        <!--header-->

        <!--chat-content-->
        <div class="chat-content">
            <div class="message-wrapper">

                <mt-loadmore :top-method="loadTop" @top-status-change="handleStatusChange" ref="loadmore" :bottom-all-loaded="allLoaded" :auto-fill="false">

                    <div
                        class="message-item"
                        v-for="(msg,index) in stat.messageList"
                        :key="index"
                        :class="[msg.messageDirection == 1 ? 'my-msg' : 'your-msg']" >

                        <div class="message-box">
                            <div class="rong-avatar">
                                <img v-if="msg.messageDirection == 1"
                                    :src="stat.currentUserInfo.portraitUri"
                                    class="rong-avatar-bd">
                                <img v-else
                                    :src="stat.targetUserInfo.portraitUri"
                                    class="rong-avatar-bd">
                            </div>

                            <!-- 文本消息 -->
                            <!-- <div class="message-text" v-if="msg.content.messageName == 'TextMessage'">
                                <pre class="user-msg">{{msg.content.content}}</pre>
                            </div> -->

                            <!-- 图片消息 -->
                            <!-- <div class="message-img" v-else-if="msg.content.messageName == 'ImageMessage'">
                                <img
                                    class="image-message"
                                    :src="msg.content.imageUri"
                                    alt="image">
                            </div> -->

                            <div class="message-text" v-if="msg.objectName == 'RC:TxtMsg'">
                                <pre class="user-msg">{{msg.content.content}}</pre>
                            </div>

                            <div class="message-img" v-else-if="msg.objectName == 'RC:ImgMsg'">
                                <img
                                    class="image-message"
                                    :src="msg.content.imageUri"
                                    alt="image">
                            </div>

                            <div class="message-text" v-else-if="msg.objectName == 'cus:tips'">
                                <!-- <pre class="user-msg">{{JSON.parse(msg.content.message.content).tips}}</pre> -->
                                <pre class="user-msg">{{msg.content.message.content.tips}}</pre>
                            </div>
                            

                            <!-- 自定义消息 -->
                            <!-- <div class="message-unknown" v-else-if="msg.content.messageName == 'UnknownMessage'">
                                <h3>{{JSON.parse(msg.content.message.content.content).shop.id}}</h3>
                                <h3>{{JSON.parse(msg.content.message.content.content).shop.real_address}}</h3>
                                <h3>{{JSON.parse(msg.content.message.content.content).shop.shop_name}}</h3>

                                <img :src="JSON.parse(msg.content.message.content.content).shop.imgs" style="
                                width: 1rem; height: 1rem;">
                            </div> -->

                            <div class="message-text message-other" v-else>
                                <pre class="message-box user-msg">暂不支持查看此消息，请在租铺宝APP上查看。</pre>
                            </div>

                        </div>
                    </div>

                </mt-loadmore>

            </div>
        </div>
        <!--chat-content-->
        <!-- footer -->
        <footer class="footer footer1">
            <div class="message-wrap">
                <input type="text" v-model="stat.sendMsgVal" id="message-content" class="message-content" name="" @focus="focusFun()">
                <span class="send-btn" @click="sendMsg">发送</span>
                <img src="../../../static/images/message/jiahao.png" class="jiahao-icon" @click="isShowSendImgFun();">
            </div>
            <div class="send-img" v-if="showSendImg">
                <div class="img-div">
                    <img class="camera-img" src="../../../static/images/message/cameraImg.png" alt="" >
                    <input type="file" accept="image/*" capture="camcorder" @change="uploadFun($event)">
                    <input type="file" accept="image/*"  @change="uploadFun($event)">
                    <span>发图片</span>
                </div>
            </div>
        </footer>
        <!-- footer -->
    </div>
</template>

<script>
import init from "@/assets/rongyun/init";
import axios from 'axios';
export default {
    data() {
        return {
            instance: "",
            stat: {
                // currentView: "chat",
                currentUserInfo: {
                    // id: "user1",
                    // id: "4",
                    nickname: "优铺顾问",
                    // region: "86",
                    // phone: "13299999999",
                    // portraitUri:"../../../static/images/shopDetail/consultant2.png"
                    portraitUri:"../../../static/images/message/userImg1.png"
                },

                targetUserInfo: {
                    // id: "user2",
                    nickname: "用户二",
                    // region: "86",
                    // phone: "13240967310",
                    portraitUri: "../../../static/images/message/userImg1.png"
                },
                messageList: [],
                sendMsgVal: "", 
            },


            imgsrc: "",

            allLoaded: false,

            //上传图片要用
            host: "",
            policy:"",
            signature: "",
            accessid: "",
            dir: "",
            expire: "",
            callback: "",
            fileImg: "",

            showSendImg: false,

            guwenId: "", //顾问id
        };
    },
    watch:{
        showHeight() {        
            if(this.docmHeight > this.showHeight){            
                this.hidshow=false        
            }else{            
                this.hidshow=true        
            }    
        }
    },

    mounted() {

        let _this = this;

        this.guwenId = this.$route.query.guwenid;

        // console.log(this.guwenId); //目标id
        let ryToken = localStorage.ryToken;
        let rcUserId = localStorage.rcUserId;

        // 用户一
        var userInfo = {
            appKey: "6tnym1br6f107", //正试
            // appKey: "c9kqb3rdc231j", //测试
            token: ryToken
        };

        // console.log(localStorage.ryToken);

        // 获取历史消息
        var callbacks = {
            CONNECTED: function(instance) {
                //传入实例参数
                //获取历史消息
                var conversationType = RongIMLib.ConversationType.PRIVATE;
                var targetId = _this.guwenId;
                instance.getHistoryMessages(
                    conversationType,
                    targetId,
                    null,
                    20,
                    {
                        onSuccess(list, hasMsg) {
                            console.log(hasMsg);
                            console.log(list);
                            //渲染会话列表
                            _this.stat.messageList = list;

                            // console.log(typeof(_this.stat.messageList[1].objectName));

                            _this.$nextTick(_this.scrollEnd);
                            return (_this.instance = instance);
                        }
                    },
                    null
                );
            },
            Success: function(id) {},
            Received: function(message) {
                console.log(message);

                _this.stat.messageList.push(message);
                _this.$nextTick(_this.scrollEnd);

            }
        };

        init(userInfo, callbacks);

        this.scrollEnd();

    },
    created() {
        this.ossData();
    },
    methods: {
        
        // 移动端键盘收回
        fixScroll() {
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if (isiOS) {
                window.scrollTo(0, 0);
            }
        },
        
        // 消息发送
        sendMsg() {
            var text = this.stat.sendMsgVal;
            if (!text) {
                return false;
            }
            var msg = new RongIMLib.TextMessage({
                content: text,
                extra: "附加信息"
            });
            var conversationType = RongIMLib.ConversationType.PRIVATE; // 私聊
            var that = this;

            var targetId = this.guwenId; // 目标 Id
            
            that.instance.sendMessage(conversationType, targetId, msg, {
                // 发送消息成功
                onSuccess: function(message) {
                    console.log(message);
                    that.stat.messageList.push(message);

                    that.stat.sendMsgVal = "";

                    that.$nextTick(that.scrollEnd);
                }
            });
        },

        // 发送图片
        sendImg(){
            let that = this;

            console.log(that.imgsrc);

            var base64Str = that.imgsrc;
            var imageUri = that.imgsrc; // 上传到自己服务器的 URL。
            var msg = new RongIMLib.ImageMessage({content: base64Str, imageUri: imageUri});
            var conversationType = RongIMLib.ConversationType.PRIVATE; // 单聊, 其他会话选择相应的会话类型即可
            var targetId = that.guwenId; // 目标 Id
            RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
                onSuccess: function (message) {

                    // message 为发送的消息对象并且包含服务器返回的消息唯一 Id 和发送消息时间戳
                    console.log('Send successfully');
                    that.imgsrc = "";

                    that.stat.messageList.push(message);

                    that.showSendImg = false;

                },
                onError: function (errorCode, message) {
                    var info = '';
                    switch (errorCode) {
                        case RongIMLib.ErrorCode.TIMEOUT:
                            info = '超时';
                            break;
                        case RongIMLib.ErrorCode.UNKNOWN:
                            info = '未知错误';
                            break;
                        case RongIMLib.ErrorCode.REJECTED_BY_BLACKLIST:
                            info = '在黑名单中，无法向对方发送消息';
                            break;
                        case RongIMLib.ErrorCode.NOT_IN_DISCUSSION:
                            info = '不在讨论组中';
                            break;
                        case RongIMLib.ErrorCode.NOT_IN_GROUP:
                            info = '不在群组中';
                            break;
                        case RongIMLib.ErrorCode.NOT_IN_CHATROOM:
                            info = '不在聊天室中';
                            break;
                    }
                    console.log('发送失败:' + info + errorCode);
                }
            });

        },

        isShowSendImgFun(){
            this.showSendImg = true;
        },

        focusFun(){
            setTimeout(function(){
                document.body.scrollTop = document.body.scrollHeight;
            },300);
            this.showSendImg = false;
        },

        loadTop(){
            let _this = this;
            var conversationType = RongIMLib.ConversationType.PRIVATE;
            var targetId = this.guwenId;
            var timestrap = null; // 默认传 null, 若从头开始获取历史消息, 请赋值为 0
            var count = 20;
            RongIMLib.RongIMClient.getInstance().getHistoryMessages(conversationType, targetId, timestrap, count, {
              onSuccess: function(list, hasMsg) {
                /* 
                    list: 获取的历史消息列表
                    hasMsg: 是否还有历史消息可以获取
                  */
                console.log('获取历史消息成功', list);

                console.log('获取历史消息成功', hasMsg);

                if(hasMsg == false){

                     _this.allLoaded = true;

                    setTimeout(function () {
                        _this.$refs.loadmore.onTopLoaded();
                    },1000)


                }else{
                    setTimeout(function () {
                        _this.stat.messageList = list.concat(_this.stat.messageList);
                        _this.$refs.loadmore.onTopLoaded();

                    },1000)
                }

              },
              onError: function(error) {
                // 请排查：单群聊消息云存储是否开通
                console.log('获取历史消息失败', error);
              }
            });
        },

        handleStatusChange(){
            var that = this;
            if(this.allLoaded == true){

            }
        },

        scrollEnd() {
            //添加完消息 跳转到最后一条
            var list = document.querySelectorAll(".message-item");
            if (list.length > 1) {
                var last = list[list.length - 1];
                last.scrollIntoView();
            }
        },

        back(){
            this.$router.go(-1);//返回上一层
        },

        ossData() {
            let url = this.changeData() + '/oss/policy'
            axios(url, {
                method: 'post',
                url: url
            }).then(ret => {
                console.log(ret);
                this.host = ret.data.host;
                this.policy = ret.data.policy;
                this.signature = ret.data.signature;
                this.accessid = ret.data.accessid;
                this.dir = ret.data.dir;
                this.expire = ret.data.expire;
                this.callback = ret.data.callback;
            }).catch(err => {
                console.log(err)
            });
        },

        uploadFun(e){
            let _this = this;

            //1. 拿到fileinput里面的文件, 这个file是一个file对象， file对象不能直接展示的
            var file = e.target.files[0];
            //需要把本地的file上传到阿里云
            this.fileImg = file;
            // console.log(this.fileImg);
            if(this.fileImg){
                _this.confirmFun()
            }

            //2. 读取文件，成功img标签可以直接使用的格式
            //FileReader类就是专门用来读文件的
            var reader = new FileReader();

            //3. 开始读文件
            //readAsDataURL: dataurl它的本质就是图片的二进制数据， 进行base64加密后形成的一个字符串， 这个字符串可以直接作用img标签的图片资源使用
            reader.readAsDataURL(file);

            //4. 因为文件读取是一个耗时操作， 所以它在回调函数中，才能够拿到读取的结果
            reader.onload = function() {
                // console.log(reader.result);
                //直接使用读取的结果
                _this.imgsrc = reader.result;
            }
        },
        random_string(len) {
            len = len || 32;
            var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz123456789';
            var maxPos = chars.length;
            var pwd = '';
            for (var i = 0; i < len; i++) {
              pwd += chars.charAt(Math.floor(Math.random() * maxPos));
            }
            return pwd;
        },
        confirmFun(){
            let _this = this;
            var ossData = new FormData();
            ossData.append('OSSAccessKeyId', _this.accessid);
            ossData.append('policy', _this.policy);
            ossData.append('Signature', _this.signature);
            //上传阿里云需要一个动态的random
            ossData.append('key', _this.dir + _this.random_string(32));
            ossData.append('success_action_status', 200); // 指定返回的状态码
            ossData.append("callback", _this.callback);
            ossData.append("file", _this.fileImg);
            this.$http.post(this.host, ossData, { headers: { "Content-Type": "multipart/form-data" } }).then(res => {
                console.log(res);
                _this.imgsrc = res.data.fileName;
                _this.imgsrc =  _this.host + '/' + res.data.fileName;
                // console.log(_this.imgsrc);
                if(_this.imgsrc){
                    _this.sendImg();
                }
            }).catch(err => {
                console.log(err)
            });
        },

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.chat{
    background: #f2f2f2;
}

/* header */
.header {
    width: 7.5rem;
    color: #333;
    line-height: .88rem;
    background: #fff;
    text-align: center;
    position: fixed;
    top: 0;
    left: auto;
    z-index: 9;
    span{
        color: #333;
        display: inline-block;
    }
    img{
        width: .2rem;
        height: .35rem;
        position: absolute;
        left: .3rem;
        top: .3rem;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
}

/* chat */
.chat-content {
    width: 7.5rem;
    overflow-y: scroll;
    height: 80vh;
    padding-top: 7vh;
    padding-bottom: 13vh;
}

.chat-content .message-wrapper {
    padding: 0 0.3rem;
}

.message-item:nth-child(n+1) {
    margin-top: .2rem;
}

.message-item:last-child {
    margin-bottom: .2rem;
}

.message-box {
    display: flex;
    font-size: .18rem;
}

.my-msg .message-box {
    flex-direction: row-reverse;
}

.you-msg .message-box {
    /*padding-left: 1.39rem;*/
}

.message-box .rong-avatar {
    flex-shrink: 0;
    width: .8rem;
    height: .8rem;
    border-radius: 50%;
    overflow: hidden;
    img {
        width: .8rem;
        height: .8rem;
        border-radius: 50%;
    }
}

/*展示文本*/
.message-box .message-text {
    position: relative;
    padding: .2rem;
    max-width: 100%;
    display: inline-block;
    vertical-align: top;
    text-align: left;
    border-radius: 2px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    /*font-size: .32rem;*/
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #333;
    min-height: .3rem;
    /*line-height: .4rem;*/
    text-align: justify;
}
/*展示图片*/
.message-img{
    position: relative;
    padding: 0 .2rem;
    img{
        width: 2.8rem;
        height: 2.24rem;
    }
}

.message-box .message-text pre {
    font-size: .3rem;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: .4rem;
    white-space: normal;
    word-break: break-all;
}

.my-msg .message-box .message-text {
    margin-right: 0.2rem;
    background: #cee4fc;
}

.your-msg .message-box .message-text {
    margin-left: 0.2rem;
    background: #fff;
}

.my-msg .message-box .message-other pre{
    font-size: .2rem;
}
.your-msg .message-box .message-other pre{
    font-size: .2rem;

}

/* footer */
/*.footer {
    position: fixed;
    left: auto;
    bottom: 0;
    width: 7.5rem;
    height: 1.6rem;
    text-align: center;
    background-color: #fff;
    border-top: 1px solid #cdd7db;
}

.footer .message-wrap {
    padding: .3rem;
}

.footer .message-content {
    height: .8rem;
    width: 5.5rem;
    resize: none;
    border: none;
    outline: none;
    font-family: "Microsoft yahei";
    float: left;
}

.footer .send-btn {
    display: inline-block;
    width: 1.2rem;
    height: .68rem;
    line-height: .68rem;
    border-radius: 40px;
    font-size: .3rem;
    color: #fff;
    background: #0099ff;
    cursor: pointer;
    position: absolute;
    right: .3rem;
    top: .3rem;
}*/

.footer1{
    position: fixed;
    left: auto;
    bottom: 0;
    width: 7.5rem;
    /*height: 4.26rem;*/
    background: #f8f8f8;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    /*border-top: 2px solid #f8f8f8;*/

    border-top: 2px solid #ccc;


    .message-wrap{
        height: .7rem;
        width: 6.9rem;
        padding: .1rem .3rem;
        /*border-top: 2px solid #f8f8f8;*/
        .message-content {
            /*height: .9rem;*/
            width: 4.8rem;
            height: .7rem;
            resize: none;
            border: 1px solid #ebebeb;
            outline: none;
            font-family: PingFangSC-Semibold,PingFang SC;
            float: left;
            box-sizing: border-box;
            border-radius: 2px;
        }
        .send-btn {
            display: inline-block;
            width: 1.2rem;
            height: .5rem;
            line-height: .5rem;
            border-radius: 40px;
            font-size: .3rem;
            color: #fff;
            background: #0099ff;
            cursor: pointer;
            position: absolute;
            right: 1rem;
            top: .24rem;
            text-align: center;
        }
        .jiahao-icon{
            width: .56rem;
            height: .56rem;
            position: absolute;
            right: .3rem;
            top: .18rem;
        }
    }
    .send-img{
        background: #fff;
        width: 7.5rem;
        height: 3.3rem;
        background: #f8f8f8;
        border-top: 2px solid #ebebeb;
        .img-div{
            width: 1.2rem;
            height: 1.2rem;
            background: #fff;
            margin-left: .64rem;
            margin-top: .56rem;
            position: relative;
            img{
                width: .52rem;
                height: .48rem;
                margin: .36rem .34rem;
            }
            input{
                width: 1.2rem;
                height: 1.2rem;
                opacity: 0;
                position: absolute;
                left: 0;
                top: 0;
            }
            span{
                font-size: .22rem;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: #666;
                line-height: .32rem;
                position: absolute;
                left: .28rem;
                bottom: -.5rem;

            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mine/messageuser.vue